export default "__VITE_ASSET__ydQX7u2r__"